"use client";

import { useTheme } from "next-themes";
import { useEffect } from "react";

export function PWAThemeColor() {
  const { theme, resolvedTheme } = useTheme();

  useEffect(() => {
    // Get the actual theme being used (resolvedTheme handles 'system' theme)
    const currentTheme = resolvedTheme || theme;
    
    // Define theme colors based on CSS variables
    const themeColors = {
      light: "#ffffff", // Light background color
      dark: "#0c0a09",  // Dark background color (matches current manifest)
    };

    // Get the appropriate color
    const themeColor = currentTheme === "dark" ? themeColors.dark : themeColors.light;

    // Update or create the theme-color meta tag
    let themeColorMeta = document.querySelector('meta[name="theme-color"]');
    
    if (!themeColorMeta) {
      themeColorMeta = document.createElement("meta");
      themeColorMeta.setAttribute("name", "theme-color");
      document.head.appendChild(themeColorMeta);
    }
    
    themeColorMeta.setAttribute("content", themeColor);

    // Also update the status bar style for iOS
    let statusBarMeta = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]');
    
    if (!statusBarMeta) {
      statusBarMeta = document.createElement("meta");
      statusBarMeta.setAttribute("name", "apple-mobile-web-app-status-bar-style");
      document.head.appendChild(statusBarMeta);
    }
    
    // Use 'black-translucent' for dark theme, 'default' for light theme
    statusBarMeta.setAttribute("content", currentTheme === "dark" ? "black-translucent" : "default");
    
  }, [theme, resolvedTheme]);

  return null; // This component doesn't render anything
}